/** Roles habituales de contactos asociados a una propiedad (propiedad_contactos.descripcion). */
export const ROLES_CONTACTO_ASOCIADO = [
  "Administrador",
  "Inquilino",
  "Otro",
  "Portero",
  "Vecino contacto",
  "Hija/o",
  "Cónyuge",
  "Interlocutor",
];
